module.exports = __webpack_public_path__ + "static/Alejandra-323852bbb23e2bf4e3ccc1608e75a08d.png";